module.exports = __webpack_public_path__ + "static/media/firstwitnessLogo.65d9da45.webp";